import * as React from 'react';
import { pageStyles } from "customStyles/common";
import { Paper } from "@mui/material";
import { ConfirmModal, CustomTable, TableTitle, useNoSearchResultsToast } from "../../../common";
import { useCallback, useEffect, useState } from "react";
import { useTableStore, useUserStore } from "../../../state";
import { useExpanded } from "../../../components/layouts/ProtectedLayout";
import { useLocation } from "react-router-dom";
import { extractPageName } from "../../../common/CustomTable/helpers";
import { useRapbackSubscription } from "../../../hooks/useRapbackSubscription";
import { useRapbackMaintenanceStore } from '../RapbackMaintenance/state/MaintenanceStore'
import { useAudit } from "hooks/useAudit";
import { useSetConfig } from 'hooks';
import { TableNames } from 'customEnums/index';

export const RapbackPrenotifications: React.FC = () => {
    const locationObj = useLocation()
    const pageName = extractPageName(locationObj.pathname)
    const { addAuditEvent } = useAudit();

    //Local State
    const [data, setData] = useState<[]>([])
    const [searched, setSearched] = useState<boolean>(false); //Set true when an advanced form multi parameter search has run
    const [value, setValue] = React.useState<any>([]);
    const [openConfirmModal, setOpenConfirmModal] = useState(false)
    const [confirmModalTitle, setConfirmModalTitle] = useState("")
    const [confirmModalContent, setConfirmModalContent] = useState("")
    const [cancelButtonText, setCancelButtonText] = useState("")
    const [confirmButtonText, setConfirmButtonText] = useState("")
    const [action, setAction] = useState("")
    const [rapbackId, setrapbackId] = useState("")
    const [displaySSN, setDisplaySSN] = useState('')
    const [showSSN, setShowSSN] = useState<boolean>(false);
    //Hooks
    const { expanded } = useExpanded()
    const userConfig = useUserStore(state => state.userConfig)

    const { userRole } = userConfig;

    // Rapback maintenance store
    const setFullName = useRapbackMaintenanceStore(state => state.setFullName)

    //Table Store
    const searchParams = useTableStore((state) => state.searchParams)
    const tableConfig = useTableStore(state => state.tableConfig)
    const simpleSearchRan = useTableStore((state) => state.simpleSearchRan)
    const setDisplayNoSearchResults = useTableStore(state => state.setDisplayNoSearchResults)
    const setPageName = useTableStore(state => state.setPageName);
    const setSearchParams = useTableStore(state => state.setSearchParams);
    const setSimpleSearchRan = useTableStore(state => state.setSimpleSearchRan);
    useNoSearchResultsToast();

    useEffect(() => {
        setPageName('rapback-prenotifications');
        console.log('RapbackPrenotifications mounting - clearing search params');
        setSearchParams([]);
        setSimpleSearchRan(false);
    }, []);

    const handleAcceptSubscription = (e, row) => {
        setrapbackId(row.rapbackSubId)
        setAction("accept_subscription")
        setConfirmModalTitle("CONFIRM ACCEPT REQUEST")
        setConfirmModalContent(`Are you sure you want to accept the Rapback Subscription request
        for ${row.fullName}?`)
        setCancelButtonText("CANCEL")
        setConfirmButtonText("ACCEPT REQUEST")
        setOpenConfirmModal(true)
        addAuditEvent("Accepted Pre-notification Request", "Rapback Pre-notification", new Date(), row.rapbackId)
        setFullName(row.fullName)
    }

    const handleDeclineSubscription = (e, row) => {
        setrapbackId(row.rapbackSubId)
        setAction("deny_subscription")
        setConfirmModalTitle("CONFIRM DECLINE REQUEST")
        setConfirmModalContent(`Are you sure you want to decline the Rapback Subscription request
        for ${row.fullName}? This action cannot be undone.`)
        setCancelButtonText("CANCEL")
        setConfirmButtonText("DECLINE REQUEST")
        addAuditEvent("Declined Pre-notification Request", "Rapback Pre-notification", new Date(), row.rapbackId)
        setOpenConfirmModal(true)
        setFullName(row.fullName)
    }

    const actionsConfig: { actionLabel: string, actionHandler: Function }[] = [
        {
            actionLabel: "Accept Subscription",
            actionHandler: handleAcceptSubscription
        },
        {
            actionLabel: "Decline Subscription",
            actionHandler: handleDeclineSubscription
        }
    ]

    const { tableHeaderCells, page, rowsPerPage } = useSetConfig(pageName, { page: 1, rowsPerPage: 25 }, TableNames.RAPBACK_PRENOTIFICATIONS, {}, actionsConfig)

    //Data
    const { data: mappedData, runCount, loading, totalRecords, fetchMaintenance, refetchParams, handleConfirmPrenotification, handleDenyPrenotification } = useRapbackSubscription(pageName, rowsPerPage,
        page,
        userRole,
        searchParams, true, TableNames.RAPBACK_PRENOTIFICATIONS)

    console.log(`Prenotification data: `, mappedData)



    const { queryDataRequest } = refetchParams

    useEffect(() => {
        setData(
            mappedData?.map((data: any, index) => {
                console.log('prenotifications setData data: ', data)
                return {
                    key: data.key,
                    fullName: data.fullName,
                    dob: data.dob,
                    ssn: data.ssn,
                    rapbackSubId: data.rapbackSubId, //is this rapback id?
                    primaryOri: data.primaryOri,
                    //secondaryOri: data.secondaryOri,
                    subscriptionDate: data.subscriptionDate,
                    expirationDate: data.expirationDate,
                    receivedDate: data.receivedDate
                }
            })
        );
    }, [mappedData?.length, mappedData])


    useEffect(() => {

        console.log('debug stuck search results useEffect: ', { runCount, searchParams, mappedData, simpleSearchRan, searched, setDisplayNoSearchResults: mappedData?.length === 0 && simpleSearchRan || mappedData?.length === 0 && searched })
        console.log('debug stuck search results useEffect: ', { conditional: runCount < 1 && searchParams.length > 0, negativeConditional: !(runCount < 1 && searchParams.length > 0) })
        if (runCount < 1 && searchParams.length > 0) {
            setDisplayNoSearchResults(false)
            return
        }
        if (mappedData?.length === 0 && simpleSearchRan || mappedData?.length === 0 && searched) {
            setDisplayNoSearchResults(true)
        }
    }, [mappedData?.length, simpleSearchRan, searched])

    const handleClickShowSSN = useCallback(async (record: string, e: any) => {
        if (displaySSN !== record) {
            setDisplaySSN(record)
            setShowSSN(!showSSN)

        } else {
            setDisplaySSN('')
            setShowSSN(!showSSN)
        }
    }, [displaySSN])

    const handleConfirmModal = async () => {
        switch (action) {
            case "accept_subscription":
                setOpenConfirmModal(false)
                await handleConfirmPrenotification(rapbackId).then(() => {
                    fetchMaintenance(queryDataRequest)
                })
                break;
            case "deny_subscription":
                setOpenConfirmModal(false)
                await handleDenyPrenotification(rapbackId).then(() => {
                    fetchMaintenance(queryDataRequest)
                })
                break;
        }
    }

    return (
        <>
            <Paper elevation={0} sx={
                {
                    ...pageStyles.pagePaperStyle,
                    maxWidth: `calc(100vw - ${expanded ? "256px" : "64px"})`
                }}>
                <TableTitle name="Rapback Pre-Notifications" />
                {
                    tableHeaderCells && (
                        <CustomTable
                            //Required props
                            tableConfig={tableConfig}
                            tableName="rapback-prenotifications"
                            loading={loading}
                            rows={data}
                            totalRecords={totalRecords}
                            currentPage={page}
                            pageSize={rowsPerPage}
                            searched={searched}
                            value={value}
                            setValue={setValue}
                            handleClickShowSSN={handleClickShowSSN}
                            displaySSN={displaySSN}
                            setSearched={setSearched}
                            //Per page props
                            defaultSortColumn="fullName"
                            rowClickHandler={(e, row) => { }}
                        />
                    )

                }

                <ConfirmModal
                    title={confirmModalTitle}
                    content={confirmModalContent}
                    cancelButtonText={cancelButtonText}
                    confirmButtonText={confirmButtonText}
                    onCancel={() => setOpenConfirmModal(false)}
                    onConfirm={handleConfirmModal}
                    open={openConfirmModal}
                />
            </Paper>{ }
        </>
    )
}
